"use strict";

//booking engine
//Open and close Booking widget

function updateTabIndex() {
	var divs = document.querySelectorAll(".booking"); // Select all elements with class "booking"

	divs.forEach(function (div) {
		var elements = div.querySelectorAll("input, button, a, textarea, select");

		if (div.classList.contains("open")) {
			elements.forEach(function (el) {
				return el.removeAttribute("tabindex");
			});
			// Set focus to the first focusable element
			if (elements.length > 0) {
				elements[0].focus();
			}
		} else {
			elements.forEach(function (el) {
				return el.setAttribute("tabindex", "-1");
			});
		}
	});
	console.log("change tabbbing");
}
if (document.getElementById('js-open-booking')) {
	var open__booking = document.getElementById('js-open-booking');
	if (open__booking) {
		open__booking.addEventListener('click', function () {
			updateTabIndex();
			//get gdpr_country
			try {
				var response = $.ajax({
					type: "GET",
					url: SITE_ROOT + "ajax/functions.php",
					data: { operation: "getCountryGDPR" },
					dataType: "json"
				});

				if (response.country != "") gdpr_country_iso = response.country;
			} catch (error) {
				console.error("GDPR Country not found:", error);
			}

			if (gdpr_country_iso == "GB" || gdpr_country_iso == "CA") {
				document.location = "/travel-agents";
				return;
			}

			if (current_lan == "ES") {
				document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators";
			} else if (current_lan == "FR") {
				document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:France;page:1;";
			} else if (current_lan == "PT") {
				document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Brazil;page:1;";
			} else if (current_lan == "IT") {
				document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Italy;page:1;";
			} else if (current_lan == "DE") {
				document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Germany;page:1;";
			} else {
				document.querySelector('.booking').classList.add('open');
				document.body.classList.add('pause-scroll');
			}
		});
	}
};

if (current_lan == "EN" && $("#js-close-booking").length > 0) {
	var close__booking = document.getElementById('js-close-booking');
	close__booking.addEventListener('click', function () {
		document.querySelector('.booking').classList.remove('open');
		document.body.classList.remove('pause-scroll');
		updateTabIndex();
	});
}

if (document.getElementById('js-open-booking-mobile')) {
	var open__bookingMobile = document.getElementById('js-open-booking-mobile');
	open__bookingMobile.addEventListener('click', function () {

		if (gdpr_country_iso == "GB" || gdpr_country_iso == "CA") {
			document.location = "/travel-agents";
			return;
		}

		if (current_lan == "ES") {
			document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators";
		} else if (current_lan == "FR") {
			document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:France;page:1;";
		} else if (current_lan == "PT") {
			document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Brazil;page:1;";
		} else if (current_lan == "IT") {
			document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Italy;page:1;";
		} else if (current_lan == "DE") {
			document.location = "/" + current_lan.toLowerCase() + "/travel-agents-tour-operators#country:Germany;page:1;";
		} else {
			document.querySelector('.booking').classList.add('open');
			document.body.classList.add('pause-scroll');
		}
	});
}